import CheckboxWithImage from "@/components/ui/checkbox-with-image.tsx";
import type { FilterProps } from "@/features/sub-families/components/filters/index.tsx";
import { useTranslations } from "@/features/translations/components/translations.tsx";

export default function SingleSelectCheckboxes({ choices, configCode, onClick }: FilterProps) {
    const t = useTranslations();

    return (
        <div className="filters--single-select-checkboxes">
            {choices.map((choice) => {
                const isDisabled = !choice.configCode;
                const checked = configCode === choice.configCode;

                const handleClick = () => {
                    if (checked) onClick(null, choice.isPossible);
                    else onClick(choice.configCode || null, choice.isPossible);
                };

                return (
                    <CheckboxWithImage
                        key={choice.value}
                        image={choice.image}
                        label={t(choice.label)}
                        description={choice.description}
                        isPossible={choice.isPossible}
                        tooltip={choice.tooltip}
                        isChecked={checked}
                        isDisabled={isDisabled}
                        onClick={handleClick}
                    />
                );
            })}
        </div>
    );
}
